import { TRoleItem } from "@/data/types";

export interface RolesState {
  items: TRoleItem[];
  currentRole: TRoleItem | null;
}

export const DefaultRolesState: RolesState = {
  items: [],
  currentRole: null,
};